<template>
    <div class="order-review-row" :class="{ 'order-review-row-bold': bold }">
        <div class="order-review-row-label">
            <slot name="label">
                {{ label }}
            </slot>
        </div>

        <div class="order-review-row-number">
            <slot name="value">
                {{ value }}
            </slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OrderReviewRow',

    props: {
        label: {
            type: String,
            default: '',
        },

        value: {
            type: String,
            default: '',
        },

        bold: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/common';

.order-review-row {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: var(--ds-spacing-200);
}

.order-review-row-bold {
    font-weight: $font-weight-bold;
}

.order-review-row-label {
    text-align: end;
}

.order-review-row-number {
    font-family: $font-table-number;
    text-align: end;
    min-width: px-to-rem(135px);
}

@media only screen and ($small) {
    .order-review-row-number {
        min-width: px-to-rem(90px);
    }
}
</style>
